import React from "react";
import { HelpCircle, Sparkles, ChevronRight } from "lucide-react";
import {
  Eye, BookOpen, Anchor, GitBranch, Search, Scroll, UserCheck, Target,
  Scale, Languages, Key, Compass, Users, Crown, Moon, ShieldAlert, Map,
  FunctionSquare, Telescope, FolderHeart, Ghost, VenetianMask, UserCog,
  MessageCircleOff, Gavel, BadgeCheck, Link2, Hammer, Brain, MessageSquare,
} from "lucide-react";

const ICONS = {
  "eye": Eye, "book-open": BookOpen, "anchor": Anchor, "git-branch": GitBranch,
  "search": Search, "scroll": Scroll, "user-check": UserCheck, "target": Target,
  "sparkles": Sparkles, "scale": Scale, "languages": Languages, "key": Key,
  "compass": Compass, "users": Users, "crown": Crown,
  "moon": Moon, "shield-alert": ShieldAlert, "map": Map,
  "function-square": FunctionSquare, "telescope": Telescope,
  "folder-heart": FolderHeart, "ghost": Ghost, "venetian-mask": VenetianMask,
  "user-cog": UserCog, "message-circle-off": MessageCircleOff,
  "gavel": Gavel, "badge-check": BadgeCheck, "link": Link2,
  "hammer": Hammer, "brain": Brain, "message-square": MessageSquare,
};

/**
 * Renders "your next sigil is X% there" hint with a progress bar. If the next
 * candidate is a mystery sigil, the name/description stay hidden.
 */
export default function NextSigilHint({ data }) {
  if (!data) {
    return null;
  }
  // Description always hidden for a "next" (unearned) sigil — name still shows.
  const Icon = ICONS[data.icon] || Sparkles;
  const color = data.color || "#a78bfa";
  return (
    <div
      data-testid="next-sigil-hint"
      className="border p-5 flex items-center gap-4"
      style={{ borderColor: `${color}55`, background: `linear-gradient(135deg, ${color}1f, ${color}05), #0a0a0a` }}
    >
      <div className="shrink-0 p-3 " style={{ backgroundColor: `${color}1a`, color }}>
        <Icon size={32} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 mb-1">
          // NEXT SIGIL · {data.progress_pct}% THERE
        </div>
        <div className="font-heading font-black uppercase tracking-tight text-lg text-white truncate">
          {data.name || "Next milestone"}
        </div>
        <div className="text-xs text-zinc-500 mt-1 italic">
          [ LOCKED — UNLOCK TO REVEAL THE CRITERIA ]
          {data.target && (
            <span className="ml-2 text-zinc-400 font-mono not-italic">
              · {data.current}/{data.target}
            </span>
          )}
        </div>
        <div className="mt-3 h-1.5 bg-white/5  overflow-hidden">
          <div
            className="h-full transition-all "
            style={{ width: `${data.progress_pct}%`, backgroundColor: color }}
          />
        </div>
      </div>
      <ChevronRight size={20} className="shrink-0 text-zinc-500" />
    </div>
  );
}
